import { Moment } from 'moment-timezone'
import React from 'react'
import styled from 'styled-components'

import AlertsList from 'pages/HehmDevice/Alerts/AlertsList'

import { sortBasedOnSeverity } from 'helpers/alerts'

import { Alert } from 'types/Alert'

type Props = {
  alerts: Array<Alert>
  showDayRthCallback: (day: Moment) => void
}

const ActiveAlerts = ({ alerts, showDayRthCallback }: Props) => {
  sortBasedOnSeverity(alerts)
  return (
    <>
      {
        !alerts.length
          ? <S.NoActiveAlerts>No Alerts</S.NoActiveAlerts>
          : <AlertsList alerts={alerts} showDayRthCallback={showDayRthCallback} />
      }
    </>
  )
}

export default ActiveAlerts

const S = {
  NoActiveAlerts: styled.h4`
    padding: 20px 0;
    font-weight: normal;
    text-transform: capitalize;
    margin: 0 0 25px 0;
  `
}
